import RepairReportStatusBadge from '#/modules/crmMgmt/aftersales/repairReport/components/RepairReportStatusBadge';
import { formatDateOrDash } from '#/utils/date';

export const repairReportSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <RepairReportStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

export const repairReportSideMsgDetailBlock = {
  fields: [
    { label: '報告單號', value: 'repairReportNo' },
    {
      label: '維修日',
      value: (row) => formatDateOrDash(row?.repairDate),
    },
    { label: '產品序號', value: 'serialNo' },
    { label: '品名', value: 'itemName' },
    { label: '問題描述', value: 'problemDescription' },
    {
      label: '配件',
      value: 'accessories',
      render: (row) => (
        <div className="side_msg-row list">
          <h3>配件</h3>
          <p className="whitespace-pre-line">{row?.accessories || '—'}</p>
        </div>
      ),
    },
    { label: '處理方式', value: 'resolution' },
    { label: '備註', value: 'remark' },
  ],
};
